import { Injectable } from '@angular/core';
import { filter, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageListenerService {

  constructor() { }

  storageListener$(storageKey:string): Observable<any> {
    return new Observable((observer) => {
      const storageListener = (e:any) => {
        observer.next(e);
      };
      window.addEventListener('storage', storageListener);
      // Clean up the event listener when unsubscribed
      return () => {
        window.removeEventListener('storage', storageListener);
      };
    }).pipe(
      filter((event:any) => event?.key === storageKey && event?.newValue)
    );
  }
}
